import BestSeller from './BestSeller';

export default BestSeller;
